import { useQuery } from '@tanstack/react-query';

import { DesignItemDto, FindDesignItemParams } from '@app/integ-apigee-interfaces';
import { Axios } from '@app/web-components';

const ITEMS_ALL_QUERY_KEY = 'ITEMS_ALL_QUERY_KEY';

const itemKeys = {
  all: [ITEMS_ALL_QUERY_KEY] as const,
  lists: () => [...itemKeys.all, 'list'] as const,
  list: (filters: object) => [...itemKeys.lists(), filters] as const,
};

export const useFindProductFamily = (params: FindDesignItemParams) => {
  const axios = Axios.useAxiosApi();

  return useQuery<DesignItemDto[]>({
    queryKey: itemKeys.list(params),
    queryFn: async () => {
      const { data } = await axios.post('design-item/product-family/find', params);
      return data;
    },
  });
};
